import {Button, Card, Modal} from 'react-bootstrap'
import React, { useEffect, useState, Fragment} from 'react'
import { connect } from 'react-redux'
import ModalBitacora from '../../../containers/modalBitacora'
import {getCBPaymentSituation, getRecordLiquidation, getCBCoin, postRecordLiquidation, cleanState} from '../../../store/actions'

import { LoadingComponent } from 'recupero-comunes'
import FormTotalLoss from './FormTotalLoss'
import FormCivilLiability from './FormCivilLiability'
import FormParcialLoss from './FormParcialLoss'
import Menssage from '../../../components/common/mensage'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { validationSchemaLiquidation } from '../../../utils/validationSchema'
import { Formik, Form } from 'formik'
import moment from 'moment'
import {CarpetaDigitalComponent} from 'reccol-caso-general'

const FormRecordLiquidation = ({
  data,
  user,
  gestionCase,
  pais,
  form,
  idCaso,
  idOrgano,
  onGetCbCoin,
  paisOrganizacion,
  onGetCBPaymentSituation,
  onGetRecordLiquidation,
  onCleanState,
  onPostRecordLiquidation,
  areaTrabajo,
  idImplicado
}) => {
  useEffect(() => {
    onGetRecordLiquidation({
      idCaso: gestionCase.IdCaso,
      idImplicado: '0',
      idOrganizacion: gestionCase.Compania,
      tipoGestion: gestionCase.IdTipoGestion,
      tipoSiniestro: gestionCase.IdTipoSiniestro
    })
    onGetCBPaymentSituation({
      concepto: 230
    })
    onGetCbCoin({
      pais: pais,
      clasBien: gestionCase.CodClasificacionCaso
    })
  }, [data.loading])

  const options = {
    gestionCase,
    form,
    idCaso,
    idOrgano,
    user,
    data,
    pais: paisOrganizacion
  }
  const initialValues = {
    idCaso: gestionCase.IdCaso,
    idImplicadoCaso: idImplicado,
    idOrganizacion: gestionCase?.Compania,
    siniestro: gestionCase?.Siniestro,
    tipoSiniestro: gestionCase?.IdTipoSiniestro,
    tipoGestion: gestionCase?.IdTipoGestion,
    idLiquidador: data?.liquidation?.idLiquidador,
    idAnalistaSin: gestionCase?.IdAnalistaSiniestro,
    codMoneda: data?.liquidation?.codMoneda,
    idUsuario: user,
    mdaIndemniza: data?.liquidation?.codMonedaIndeminza
      ? data?.liquidation?.codMonedaIndeminza
      : null,
    mtoIndemnizacion: data?.liquidation?.mtoIndemnizacion,
    indInformeLiquida:
      data?.liquidation?.indInformeLiquida === 1 ? true : false,

    fechaInforme:
      data?.liquidation?.fechaInforme &&
      data?.liquidation?.fechaInforme !== '0000-00-00'
        ? data?.liquidation?.fechaInformeFmt
        : null,
    fechaPago:
      data?.liquidation?.fechaPago &&
      data?.liquidation?.fechaPago !== '0000-00-00'
        ? data?.liquidation?.fechaPagoFmt
        : null,

    indFiniquito: data?.liquidation?.indFiniquito === 1 ? true : false,
    mdaPago: data?.liquidation?.codMonedaPago
      ? data?.liquidation?.codMonedaPago
      : null,
    mtoPago: data?.liquidation?.mtoPago,
    situacionPago: data?.liquidation?.codSituacionPago,
    fecUltimoPago: null,
    mdaProvision: data?.liquidation?.codMonedaProvision
      ? data?.liquidation?.codMonedaProvision
      : null,
    mtoProvision: data?.liquidation?.mtoProvision,
    mdaSalvataje: data?.liquidation?.codMonedaSalvataje
      ? data?.liquidation?.codMonedaSalvataje
      : null,
    mtoSalvataje:
      data?.liquidation?.mtoSalvataje || data?.liquidation?.mtoSalvataje !== 0
        ? data?.liquidation?.mtoSalvataje
        : null,
    polizaRCexceso: data?.liquidation?.datosRcExceso?.polizaRcExceso,
    siniestroRCexceso: data?.liquidation?.datosRcExceso?.siniestroRcExceso,
    fechaSiniestro: gestionCase?.FechaSiniestro
      ? gestionCase?.FechaSiniestroFmt
      : null,
    mdaCobertura: data?.liquidation?.datosRcExceso?.mdaCobertura
      ? data?.liquidation?.datosRcExceso?.mdaCobertura
      : '',
    mtoCobertura:
      data?.liquidation?.datosRcExceso?.mtoCobetura ||
      data?.liquidation?.datosRcExceso?.mtoCobetura !== 0
        ? data?.liquidation?.datosRcExceso?.mtoCobetura
        : null
  }

  const [loading, setLoading] = useState(false)
  const history = useNavigate()
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const [formValues, setFormValues] = useState({})
  const [mensaggeModal, setMensaggeModal] = useState('')
  const [showBitacora, setShowBitacora] = useState(false)
  const handleCloseBitacora = () => setShowBitacora(false)

  const [showCarpeta, setShowCarpeta] = useState(false)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)

  const onSubmit = (values) => {
    values.indFiniquito = values.indFiniquito ? 1 : 0
    values.indInformeLiquida = values.indInformeLiquida ? 1 : 0
    setShow(true)
    setFormValues(values)
  }

  const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
  const onBack = () => {
    onCleanState()
    history('/area-gestion-compania', {
      state: {queryState}
    })
  }

  const onBitacora = () => {
    setShowBitacora(true);
  }

  const onSubmitModal = async () => {
    setShow(false)
    await setLoading(true)
    try {
      await onPostRecordLiquidation(formValues)
    } catch (error) {
      toast.error(error)
    } finally {
      await setLoading(false)
      onBack()
    }
  }

  useEffect(() => {
    setMensaggeModal(
      gestionCase.IdTipoGestion === 207002
        ? 'Esta Seguro que desea Actualizar La Liquidación del Siniestro - Responsabilidad Civil'
        : gestionCase.IdTipoSiniestro === 15001
        ? 'Esta Seguro que desea Actualizar La Liquidación del Siniestro - Pérdida Total'
        : gestionCase.IdTipoSiniestro === 15005
        ? 'Esta Seguro que desea Actualizar La Liquidación del Siniestro - Pérdida Parcial'
        : ''
    )
  })

  useEffect(() => {
    if (data.response) {
      toast(data.response)
      data.response = null
    }
  }, [data.response])

  const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined) {
        const [dia, mes, ano] = fecha?.split('-')
        const fechaFormat = [ano, mes, dia].join('-')

        return fechaFormat
    } else
        return null
}

  return (
  <>
    <style type='text/css'>
    {`
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;

    }
    .btn-actualizar:hover{
        background-color: #d3807f;
      color: #FFFFFF;
    }
    .btn-volver {
      color: #66CCCC;
      border: 1px solid #C00
      width: 140px;
    }
    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    .btn-carpeta {
      background-color: #D59B49;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    `}
      </style>
    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
      <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
        idCaso={idCaso}
        idImplicado={idImplicado}
        idOrganizacionCaso={idOrgano}
        prototipo={2}            
        />     
  </Modal>
    <div>
      <LoadingComponent show={loading || data.loading || form.loading} />
      {Object.keys(data?.liquidation).length > 0 ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchemaLiquidation(
            new Date(gestionCase.FechaSiniestro)
          )}
          onSubmit={onSubmit}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <Form>
              {gestionCase.IdTipoGestion === 207002 ? (
                <FormCivilLiability
                  {...options}
                  errors={errors}
                  touched={touched}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              ) : gestionCase.IdTipoSiniestro === 15001 ? (
                <FormTotalLoss
                  {...options}
                  errors={errors}
                  touched={touched}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              ) : gestionCase.IdTipoSiniestro === 15005 ? (
                <FormParcialLoss
                  {...options}
                  errors={errors}
                  touched={touched}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              ) : null}
              <div
                className='d-grid gap-2 d-md-block float-left mt-4 mb-2'
                style={{
                  float: 'right'
                }}
              >
                  <Button
                    className='m-2 w-auto'
                    variant='outline-info'
                    onClick={() => onBack()}
                  >
                    {form['antecliquida-btn-volver']}
                  </Button>
                  <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta}> 
                    {form['antecliquida-btn-cd']}
                  </Button>
                  <Button
                    className='m-2'
                    variant='bitacora'
                    onClick={() => onBitacora()}
                  >
                    {form['antecliquida-btn-bitacora']}
                  </Button>

                  <Button type='submit' variant='actualizar'>
                    {form['antecliquida-btn-actualizar']}
                  </Button>
              </div>
              {show && (
                <Menssage
                  show={show}
                  handleClose={handleClose}
                  message={mensaggeModal}
                  onSubmitModal={() => onSubmitModal()}
                />
              )}
              {showBitacora && (
                <ModalBitacora
                  show={showBitacora}
                  handleClose={handleCloseBitacora}
                  idCaso={idCaso}
                  rutcia={idOrgano}
                  user
                />
              )}
            </Form>
          )}
        </Formik>
      ) : null}
    </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  data: state.recordLiquidation
})

const mapDispatchToProps = (dispatch) => ({
  onGetCbCoin: (query) => dispatch(getCBCoin(query)),
  onGetCBPaymentSituation: (query) => dispatch(getCBPaymentSituation(query)),
  onGetRecordLiquidation: (query) => dispatch(getRecordLiquidation(query)),
  onPostRecordLiquidation: (body) => dispatch(postRecordLiquidation(body)),
  onCleanState: () => dispatch(cleanState())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormRecordLiquidation)
